import { FC } from 'react';
import { Stack } from '@mui/material';

import { FilterGroup } from '@models/SearchFilter';

import ExportSearchQueryButton from './EditSearchQueryButton';
import SaveAsCollectionButton from './SaveAsCollectionButton';

export type SearchToolbarActionsProps = {
  disableSaveSearch?: boolean;
  filter: FilterGroup;
};

const SearchToolbarActions: FC<SearchToolbarActionsProps> = ({ disableSaveSearch, filter }) => (
  <Stack direction='row'>
    <SaveAsCollectionButton disableSaveSearch={disableSaveSearch} filter={filter} />
    <ExportSearchQueryButton />
  </Stack>
);

export default SearchToolbarActions;
